import React from 'react'
import {
  GrantPlanCount,
  GrantPlanItem,
  GrantPlanSummary,
  GrantRowDetail,
  GrantRowEmail,
  GrantRowList,
  GrantRowMain,
  GrantScroll,
  GrantSection,
  GrantSectionHeader,
  GrantSectionHint,
  GrantSectionTitle,
  GrantSplitRow,
  StatusPill,
} from './UserManagement.styles'
import { getDisplayStatusConfig } from './userDisplay'
import type { GrantSectionModel } from './grantSections'

interface GrantPlanSectionsProps {
  sections: GrantSectionModel[]
}

/** What submitting will do, grouped by action, with each row's status beside it. */
export const GrantPlanSections = ({ sections }: GrantPlanSectionsProps) => (
  <>
    {/* Redundant with the lone section header when there is only one. */}
    {sections.length > 1 ? (
      <GrantPlanSummary>
        {sections.map((section) => (
          <GrantPlanItem key={section.key}>
            <GrantPlanCount>{section.rows.length}</GrantPlanCount>{' '}
            {section.summaryLabel}
          </GrantPlanItem>
        ))}
      </GrantPlanSummary>
    ) : null}

    <GrantScroll>
      {sections.map((section) => (
        <GrantSection key={section.key}>
          <GrantSectionHeader>
            <GrantSectionTitle>
              {section.title} ({section.rows.length})
            </GrantSectionTitle>
            <GrantSectionHint>{section.hint}</GrantSectionHint>
          </GrantSectionHeader>
          <GrantRowList>
            {section.rows.map(({ row, detail }) => {
              const status = getDisplayStatusConfig(row)
              return (
                <GrantSplitRow key={row.email}>
                  <GrantRowMain>
                    <GrantRowEmail>{row.email}</GrantRowEmail>
                    <GrantRowDetail title={detail.title || undefined}>
                      {detail.text}
                    </GrantRowDetail>
                  </GrantRowMain>
                  <StatusPill $variant={status.variant}>
                    {status.label}
                  </StatusPill>
                </GrantSplitRow>
              )
            })}
          </GrantRowList>
        </GrantSection>
      ))}
    </GrantScroll>
  </>
)
